module.exports = __webpack_public_path__ + "static/media/mission.9801fa6c.svg";